import { atom } from 'recoil';
import type { CacheDocProps } from './types';

export const DocPropsCacheState = atom<CacheDocProps>({
  key: 'doc-props-state',
  default: {},
});
